var _path, _rect, _path2, _rect2, _rect3, _rect4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 22.5C0 18.3579 3.35786 15 7.5 15H74.5C78.6421 15 82 18.3579 82 22.5C82 26.6421 78.6421 30 74.5 30H7.5C3.35786 30 0 26.6421 0 22.5Z",
    fill: "#44AC34"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 35,
    y: 30,
    width: 75,
    height: 15,
    rx: 7.5,
    fill: "#44AC34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47 7.5C47 3.35786 50.3579 0 54.5 0H125V8C125 11.866 121.866 15 118 15H54.5C50.3579 15 47 11.6421 47 7.5Z",
    fill: "#44AC34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 242,
    y: 86,
    width: 69,
    height: 15,
    rx: 7.5,
    transform: "rotate(180 242 86)",
    fill: "#44AC34"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 256,
    y: 71,
    width: 91,
    height: 15,
    rx: 7.5,
    transform: "rotate(180 256 71)",
    fill: "#44AC34"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 207,
    y: 101,
    width: 94,
    height: 15,
    rx: 7.5,
    transform: "rotate(180 207 101)",
    fill: "#44AC34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.583 50.5003C169.583 61.6615 165.149 72.3656 157.257 80.2577C149.365 88.1499 138.661 92.5837 127.5 92.5837C116.339 92.5837 105.635 88.1499 97.7424 80.2577C89.8503 72.3656 85.4165 61.6615 85.4165 50.5003C85.4165 39.3391 89.8503 28.6351 97.7424 20.7429C105.635 12.8508 116.339 8.41699 127.5 8.41699C138.661 8.41699 149.365 12.8508 157.257 20.7429C165.149 28.6351 169.583 39.3391 169.583 50.5003ZM148.699 34.5613C148.324 34.1868 147.876 33.892 147.384 33.6944C146.892 33.4969 146.364 33.4006 145.834 33.4114C145.304 33.4222 144.781 33.5399 144.297 33.7573C143.813 33.9748 143.378 34.2876 143.018 34.677L124.749 57.9543L113.739 46.939C112.991 46.2421 112.001 45.8627 110.979 45.8808C109.957 45.8988 108.982 46.3129 108.259 47.0357C107.536 47.7586 107.122 48.7338 107.104 49.7559C107.086 50.778 107.466 51.7672 108.163 52.5151L122.082 66.4394C122.457 66.8137 122.903 67.1086 123.395 67.3066C123.886 67.5046 124.412 67.6015 124.942 67.5917C125.472 67.5819 125.994 67.4655 126.478 67.2494C126.961 67.0334 127.397 66.7221 127.758 66.3342L148.757 40.0847C149.473 39.3403 149.869 38.345 149.859 37.3122C149.849 36.2795 149.435 35.2918 148.705 34.5613H148.699Z",
    fill: "#44AC34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8bcf3ef47eebd053c97dca58a42d7484.svg";
export { ForwardRef as ReactComponent };